import { Phone, Mail, MapPin, Clock } from "lucide-react";

const ContactPage = () => {
  const contactInfo = [
    {
      icon: <Phone className="h-6 w-6" />,
      title: "Phone",
      details: ["(617) 913-2934"],
      action: "tel:+16179132934",
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: "Email",
      details: ["rafael@kdatruckingllc.com"],
      action: "mailto:rafael@kdatruckingllc.com",
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: "Address",
      details: ["Revere, MA 02151"],
      action: null,
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: "Business Hours",
      details: ["Monday - Friday: 7am - 7pm", "Saturday: 8am - 2pm"],
      action: null,
    },
  ];

  return (
    <div className="min-h-screen" data-testid="contact-page">
      {/* Header */}
      <section className="bg-slate-900 py-20">
        <div className="section-container">
          <p className="text-orange-500 font-bold uppercase tracking-widest mb-4 text-sm">
            Contact Us
          </p>
          <h1 className="heading-1 text-white">
            We're Here to Serve You
          </h1>
          <p className="text-slate-400 mt-4 text-lg max-w-xl">
            Have questions? Our team is ready to help with all your transportation needs.
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-20 bg-slate-50">
        <div className="section-container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {contactInfo.map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200"
                data-testid={`contact-card-${index}`}
              >
                <div className="bg-orange-100 w-14 h-14 rounded-sm flex items-center justify-center text-orange-600 mb-6">
                  {item.icon}
                </div>
                <h3 className="heading-3 text-slate-900 mb-4">{item.title}</h3>
                {item.details.map((detail, idx) => (
                  item.action ? (
                    <a
                      key={idx}
                      href={item.action}
                      className="block text-slate-600 hover:text-orange-600 transition-colors"
                    >
                      {detail}
                    </a>
                  ) : (
                    <p key={idx} className="text-slate-600">{detail}</p>
                  )
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20">
        <div className="section-container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-orange-600 font-bold uppercase tracking-widest mb-4 text-sm">
                Our Location
              </p>
              <h2 className="heading-2 text-slate-900 mb-6">
                Visit Us in Massachusetts
              </h2>
              <p className="text-slate-600 text-lg mb-8 leading-relaxed">
                Our offices are located in Revere, Massachusetts, 
                allowing us to efficiently serve the entire United States.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <MapPin className="h-6 w-6 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-slate-900">KDA Trucking LLC</p>
                    <p className="text-slate-600">Revere, MA 02151</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-96 bg-slate-200 rounded-sm overflow-hidden" data-testid="map-container">
              <iframe
                title="KDA Trucking Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47177.04889475646!2d-71.0322193!3d42.4084302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e371213281e2a5%3A0xd4b8a65c99af5a09!2sRevere%2C%20MA%2002151!5e0!3m2!1sen!2sus!4v1650000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="bg-slate-900 py-16" data-testid="emergency-section">
        <div className="section-container text-center">
          <h2 className="heading-2 text-white mb-4">
            Need Urgent Assistance?
          </h2>
          <p className="text-slate-400 mb-8 max-w-xl mx-auto">
            Our dispatch team is available 24/7 for transportation emergencies.
          </p>
          <a
            href="tel:+16179132934"
            className="inline-flex items-center gap-3 bg-orange-600 hover:bg-orange-700 text-white rounded-sm font-bold uppercase tracking-wider px-8 py-4 shadow-lg hover:shadow-orange-500/30 transition-all duration-200"
            data-testid="emergency-call-button"
          >
            <Phone className="h-5 w-5" />
            Call Now: (617) 913-2934
          </a>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
